module.exports = "<app-event-form-mobile (newEvent)=\"onNewEvent($event)\"></app-event-form-mobile>\n"